import { render, staticRenderFns } from "./ApplicantContacts.vue?vue&type=template&id=65a7af70&"
import script from "./ApplicantContacts.vue?vue&type=script&lang=js&"
export * from "./ApplicantContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports